
class CapViewRouteStopTimes {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'view_route_stop_times'
}

function create(config) {
  return new CapViewRouteStopTimes(config)
}

export default {
  key,
  create,
}
